import { useParams } from "react-router-dom";
import { useState } from "react";
import axios from "axios";

const ResetPassword = () => {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const submit = async () => {
    if (password !== confirm) {
      alert("Passwords do not match");
      return;
    }

    await axios.post("https://api.propertygalleria.in/reset-password", {
      token,
      password
    });

    alert("Password reset successful");
  };

  return (
    <div className="user-container">
      <h2>Reset Password</h2>
      <input type="password" placeholder="New Password" onChange={e=>setPassword(e.target.value)} />
      <input type="password" placeholder="Confirm Password" onChange={e=>setConfirm(e.target.value)} />
      <button onClick={submit}>Reset</button>
    </div>
  );
};

export default ResetPassword;
